// utils/serviceAvailability.js
export const isServiceUnavailable = () => {
  // const currentTime = new Date();
  // const istOffset = 5.5 * 60 * 60 * 1000;
  // const istTime = new Date(currentTime.getTime() + istOffset);

  // const hours = istTime.getUTCHours();

  // return hours >= 20 || hours < 10;
  return false
};